import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function PolicyLayout({ title, lastUpdated, children, testId }) {
  return (
    <div data-testid={testId} className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <p className="text-overline text-primary">Legal</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mt-3">{title}</h1>
        <p className="text-sm text-muted-foreground mt-4">Last updated: {lastUpdated}</p>
        <div className="prose prose-slate max-w-none mt-10 text-[15px] leading-relaxed text-foreground/85 space-y-5">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
